import React, { useEffect, useState } from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import StepsLineWithCircles from "../../components/Steps/StepsLineWithCircles";
import RenderQuestion from "./RenderQuestion";
import useUsers from "../../store/users/usersContext";
import useNotification from "../../store/notification/notificationContext";
import { NOTIFICATIONS } from "../../config";
import useApp from "../../store/app/appContext";

function UpdateMedicalQuestionnaire({
  setShowUpdateMedicalQuestionnaire,
  showUpdateMedicalQuestionnaire,
  patientInfo,
  viewOnly = false
}) {
  const { setNotification } = useNotification();
  const { addPatientInfo, updatePatientInfo } = useUsers();
  const { getAllMedicalQuestionnaire } = useApp()
  
  const [registerSteps, setRegisterSteps] = useState([
    { name: "Reasons for visiting", step: 1, status: "current" },
    { name: "Patient Illness", step: 2, status: "upcoming" },
  ]);
  
  const [medicalQuestionnaire, setMedicalQuestionnaire] = useState();
  const [answers, setAnswers] = useState();
  const [id, setId] = useState();

  const step1Questions =
    medicalQuestionnaire &&
    medicalQuestionnaire.filter((q) => !q.question_group);
  const step2Questions =
    medicalQuestionnaire &&
    medicalQuestionnaire.filter((q) => q.question_group);

  useEffect(() => {
    getAllMedicalQuestionnaire().then((data) => {
      data = data.sort((a,b) => a.id - b.id)
      setMedicalQuestionnaire(data);
    });
  }, [])

  useEffect(() => {
    if (patientInfo && patientInfo.question_answers) {
      setId(patientInfo._id);
      patientInfo.question_answers.length ? setAnswers(patientInfo.question_answers) : setInitialAnswers() 
    }
    else {
      setInitialAnswers()
    }
  }, [medicalQuestionnaire, patientInfo]);



  const setInitialAnswers = () => {
    if (medicalQuestionnaire && !answers) {
      let initialanswers = medicalQuestionnaire.map((q) => {
        return {
          question_id: q.id,
          answer: q.question_type === "multiple" ? [] : null,
          value: null,
        };
      });
      setAnswers(initialanswers);
    }
  }

  const currentStep = registerSteps.find(
    (element) => element.status === "current"
  );

  const handleCancel = () => {
    setShowUpdateMedicalQuestionnaire(false);
    setId();
    setRegisterSteps([
      { name: "Reasons for visiting", step: 1, status: "current" },
      { name: "Patient Illness", step: 2, status: "upcoming" },
    ]);
  };

  const handleNext = () => {
    if (currentStep.step === 2) {
      let completed = getStatus(step2Questions);
      if (!completed) {
        showNotification();
      } else if (id) {
        //if ID, then user already has questionnaire answers -- updating instead of adding
        updatePatientInfo(answers).then((data) => {
          setNotification({
            show: true,
            type: NOTIFICATIONS.TYPE.SUCCESS,
            title: "Success",
            message: "Medical questionnaire updated successfully!",
          });
          setShowUpdateMedicalQuestionnaire(false);
        });
      } else {
        addPatientInfo(answers).then((data) => {
          setNotification({
            show: true,
            type: NOTIFICATIONS.TYPE.SUCCESS,
            title: "Success",
            message: "Medical questionnaire updated successfully!",
          });
          setShowUpdateMedicalQuestionnaire(false);
        });
      }
    } else {
      let completed = getStatus(step1Questions);
      if (completed) {
        setRegisterSteps([
          { name: "Reasons for visiting", step: 1, status: "complete" },
          { name: "Patient Illness", step: 2, status: "current" },
        ]);
      } else {
        showNotification();
      }
    }
  };

  const getStatus = (questions) => {
    let completed = true;
    questions.map((q) => {
      let matched = answers.filter((a) => a.question_id == q.id)[0];
      if (matched.answer === null || matched.answer === "") {
        completed = false;
      }
    });
    return completed;
  };

  const showNotification = () => {
    setNotification({
      show: true,
      type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
      title: "Error",
      message: "Please answer all the questions",
    });
  };

  const handleBack = () => {
    setRegisterSteps([
      { name: "Reasons for visiting", step: 1, status: "current" },
      { name: "Patient Illness", step: 2, status: "upcoming" },
    ]);
  };

  const setAnswer = (question, value) => {
    let updated = answers.map((answer) => {
      if (answer.question_id === question.id) {
        if (question.question_type === "multiple") {
          if (answer.answer.includes(value)) {
            answer.answer = answer.answer.filter((a) => a !== value);
          } else {
            answer.answer.push(value);
          }
        } else {
          answer.answer = value;
        }
      }
      return answer;
    });
    setAnswers(updated);
  };

  const setAdditionalValue = (anwerDetails, value) => {
    let updated = answers.map((a) => {
      if (a.question_id === anwerDetails.question_id) {
        a.value = value;
      }
      return a;
    });
    setAnswers(updated);
  };

  return (
    <Modal
      className="md:max-w-4xl md:max-h-l"
      title={"Medical Questionnaire"}
      show={showUpdateMedicalQuestionnaire}
      hide={handleCancel}
    >
      <div className="flex flex-col justify-between w-full md:pl-20 md:pr-20 sm:pl-1 sm:pr-1 h-full">
        <div className="w-full mt-6 mb-12">
          <StepsLineWithCircles steps={registerSteps} />
        </div>
        <div className="mt-5">
          {currentStep.step === 1 &&
            step1Questions &&
            step1Questions.map((question, index) => {
              let data =
                answers && answers.find((a) => a.question_id === question.id);
              return (
                <RenderQuestion
                  data={question}
                  index={index}
                  answerData={data}
                  setAnswer={setAnswer}
                  setAdditionalValue={setAdditionalValue}
                  viewOnly={viewOnly}
                />
              );
            })}

          {currentStep.step === 2 && (
            <div className="mb-2">Do you suffer from following issues?</div>
          )}
          {currentStep.step === 2 &&
            step2Questions &&
            step2Questions.map((question, index) => {
              let data =
                answers && answers.find((a) => a.question_id === question.id);
              return (
                <RenderQuestion
                  data={question}
                  index={index}
                  answerData={data}
                  setAnswer={setAnswer}
                  setAdditionalValue={setAdditionalValue}
                  viewOnly={viewOnly}
                />
              );
            })}

          {viewOnly ? 
          <div className='flex justify-end mt-4'>
            <SecondaryButton text={currentStep.step !== 1 ? "Back" : "Next"} onClick={currentStep.step !== 1 ? handleBack : handleNext} />
          </div>
          :
          <div className="flex">
            {currentStep.step !== 1 && (
              <div className="w-full">
                <SecondaryButton
                  onClick={handleBack}
                  className="mt-8 mr-5"
                  large
                  text={"BACK"}
                />
              </div>
            )}
            <div className={"w-full"}>
              <PrimaryButton
                onClick={handleNext}
                className="mt-8"
                large
                text={currentStep.step === 2 ? "Submit" : "NEXT"}
              />
            </div>
          </div>}
        </div>
      </div>
    </Modal>
  );
}

export default UpdateMedicalQuestionnaire;
